import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Desktop } from './components/OS/Desktop';
import { ThemeProvider } from './contexts/ThemeContext';
import { WindowProvider } from './contexts/WindowContext';
function AppContent() {
  return <div className="w-full min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900" data-id="element-0">
      <Desktop data-id="element-1" />
    </div>;
}
export function App() {
  return <HelmetProvider data-id="element-2">
      <ThemeProvider data-id="element-3">
        <WindowProvider data-id="element-4">
          <AppContent data-id="element-5" />
        </WindowProvider>
      </ThemeProvider>
    </HelmetProvider>;
}